import { useRegistrationStore } from '@/lib/store/registrationStore'
import { storageRepository } from '@/lib/api/repositories/storageRepository'

export function useImageUpload() {
  const store = useRegistrationStore()

  const uploadProfilePhoto = async (file: File, playerName?: string): Promise<string> => {
    try {
      store.setUploadingProfilePhoto(true)
      store.setProfilePhotoPreview(URL.createObjectURL(file))

      const url = await storageRepository.uploadProfilePhoto(file, playerName)

      store.setProfilePhotoUrl(url)
      return url
    } catch (error) {
      console.error('Failed to upload profile photo:', error)
      store.setProfilePhotoPreview(null)
      throw error
    } finally {
      store.setUploadingProfilePhoto(false)
    }
  }

  const uploadPaymentScreenshot = async (file: File, playerName?: string): Promise<string> => {
    try {
      store.setUploadingPaymentScreenshot(true)
      store.setPaymentScreenshotPreview(URL.createObjectURL(file))

      const url = await storageRepository.uploadPaymentScreenshot(file, playerName)

      store.setPaymentScreenshotUrl(url)
      return url
    } catch (error) {
      console.error('Failed to upload payment screenshot:', error)
      store.setPaymentScreenshotPreview(null)
      throw error
    } finally {
      store.setUploadingPaymentScreenshot(false)
    }
  }

  return {
    uploadProfilePhoto,
    uploadPaymentScreenshot,
    isUploadingProfilePhoto: store.isUploadingProfilePhoto,
    isUploadingPaymentScreenshot: store.isUploadingPaymentScreenshot,
    profilePhotoPreview: store.profilePhotoPreview,
    paymentScreenshotPreview: store.paymentScreenshotPreview,
  }
}
